// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_3jVKi","icon":"index_icon_3qICh"};